function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "sketch",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M30.031,0H.969A1.023,1.023,0,0,0,0,1.069,1.023,1.023,0,0,0,.969,2.138H30.031A1.023,1.023,0,0,0,31,1.069,1.023,1.023,0,0,0,30.031,0Z",
  transform: "translate(0 8.552)",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M16.864,9.07,9.262.312a.965.965,0,0,0-1.421,0L.24,9.07a.99.99,0,0,0,.08,1.374.935.935,0,0,0,1.342-.082l6.891-7.94,6.891,7.94a.935.935,0,0,0,1.342.082A.99.99,0,0,0,16.864,9.07Z",
  transform: "translate(6.414)",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M14.74,28.5.209,10.216A.953.953,0,0,1,.149,9.11l4.844-7.7A.968.968,0,0,1,5.717.967L15.4,0a1.094,1.094,0,0,1,.217,0l7.751.962a.963.963,0,0,1,.606.321l6.781,7.7a.958.958,0,0,1,.033,1.229L16.261,28.5a.974.974,0,0,1-1.521,0Z",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M9.545,18.968,1.849.591a.963.963,0,1,0-1.774.751l7.7,18.377a.964.964,0,0,0,.887.592.982.982,0,0,0,.373-.075A.97.97,0,0,0,9.545,18.968Z",
  transform: "translate(6.414 8.552)",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  "data-name": "Path",
  d: "M9.032.077a.958.958,0,0,0-1.26.516L.076,18.968a.963.963,0,1,0,1.774.75l7.7-18.375A.97.97,0,0,0,9.032.077Z",
  transform: "translate(14.966 8.552)",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-5",
  "data-name": "Path",
  d: "M4.244,8.426,2.105.73a1.082,1.082,0,0,0-1.3-.7A.957.957,0,0,0,.033,1.2l2.138,7.7a1.05,1.05,0,0,0,1.035.729,1.185,1.185,0,0,0,.259-.029A.959.959,0,0,0,4.244,8.426Z",
  transform: "translate(4.276 1.069)",
  fill: "#ffca29"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6",
  "data-name": "Path",
  d: "M1.069,0A1.02,1.02,0,0,0,0,.962v7.7a1.02,1.02,0,0,0,1.069.962,1.02,1.02,0,0,0,1.069-.962V.962A1.02,1.02,0,0,0,1.069,0Z",
  transform: "translate(22.448 1.069)",
  fill: "#ffca29"
}));

function SvgSketch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 28.862,
    viewBox: "0 0 31 28.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketch);
export default __webpack_public_path__ + "static/media/sketch.e8263865.svg";
export { ForwardRef as ReactComponent };